import axios from 'axios';

// Configuración base para el servicio de paquetes
const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:3000';

const packageAPI = axios.create({
  baseURL: `${API_BASE_URL}/package`,
  timeout: Number(process.env.REACT_APP_API_TIMEOUT) || 10000,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Interceptor para manejo de errores
packageAPI.interceptors.response.use(
  (response) => response,
  (error) => {
    console.error('Package Service Error:', error);
    return Promise.reject(error);
  }
);

export const packageService = {
  // Obtener todos los paquetes públicos (activos y en rango de fechas)
  getAllPublic: async () => {
    try {
      const response = await packageAPI.get('/public');
      return response.data;
    } catch (error) {
      throw new Error('Error al obtener los paquetes: ' + error.message);
    }
  },

  // Obtener un paquete por ID
  getById: async (id) => {
    try {
      const response = await packageAPI.get(`/${id}`);
      return response.data;
    } catch (error) {
      throw new Error(`Error al obtener el paquete ${id}: ` + error.message);
    }
  },

  // Verificar disponibilidad de un paquete para una fecha
  checkAvailability: async (packageId, checkIn) => {
    try {
      const response = await packageAPI.get(`/${packageId}/availability`, {
        params: { checkIn },
      });
      return response.data;
    } catch (error) {
      const message = error.response?.data?.message || error.message;
      throw new Error(message);
    }
  },
};

export default packageService;
